module.exports = __webpack_public_path__ + "static/media/polaris-medium.ac7996da.otf";


//////////////////
// WEBPACK FOOTER
// ./src/polaris-medium.otf
// module id = ./src/polaris-medium.otf
// module chunks = 0